import React, { useEffect, useMemo, useRef, useState } from "react";

import {
  Table,
  Button,
  Dropdown,
  Modal,
  Input,
  Pagination,
  Icon,
  Header,
  Tab,
} from "semantic-ui-react";

import moment from "moment";

import DateTextBox from "../common/DateTextBox";

import "./CardSellerSettingPackage.scss";
import { beStringToAdString } from "react-lib/utils/dateUtils";
import SunEditor from "suneditor-react";
import ButtonLoadCheck from "react-lib/appcon/common/ButtonLoadCheck";
import { formatDateBE, toApiDate, formatDateTimeToISO } from "react-lib/utils/dateUtils";
import TimeInput from "./TimeInput";

type CardSellerSettingPackageProps = {
  setProp?: any;
  buttonLoadCheck?: any;
  onEvent?: any;
  meHealthPackageList?: any;
  termsAndConditionsList?: any;
  latestTermAndConditions?: any;
  termsAndConditionsActionLogList?: any;
};

const ICON = {
  IconSetting: "/static/images/icon_setting.png",
};

const COLOR = {
  primary: "var(--primary-theme-color)",
  light_gray: "#d9d9d9",
  gray: "#a7a7a7",
};

const STATUS_OPTIONS = [
  { key: "active", text: "เปิดขาย", value: "ACTIVE" },
  { key: "inactive", text: "ยังไม่เปิดขาย", value: "INACTIVE" },
  { key: "all", text: "ทั้งหมด", value: "all" },
];

const SALE_STATUS_OPTIONS = [
  { key: "active", text: "เปิดขาย", value: "ACTIVE" },
  { key: "inactive", text: "ยังไม่เปิดขาย", value: "INACTIVE" },
];

const DEFAULT_ROWS = 5;

const ROWS_PER_PAGE = 15;

const today = new Date();
const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);

const CardSellerSettingPackage: React.FC<CardSellerSettingPackageProps> = (props) => {
  const [filterName, setFilterName] = useState("");
  const [activePage, setActivePage] = useState(1);
  const [openAddNewPackage, setOpenAddNewPackage] = useState(false);
  const [openSuccessAddNewPackage, setOpenSuccessAddNewPackage] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [selectedPackage, setSelectedPackage] = useState<any>(null);
  const [packageCode, setPackageCode] = useState("");
  const [packageName, setPackageName] = useState("");
  const [price, setPrice] = useState<string>("");
  const [credits, setCredits] = useState<string>("");
  const [startDate, setStartDate] = useState("");
  const [startTime, setStartTime] = useState("00:00");
  const [endDate, setEndDate] = useState("");
  const [endTime, setEndTime] = useState("00:00");
  const [saleStatus, setSaleStatus] = useState("");
  const [filterStatus, setFilterStatus] = useState("all");
  const [createdPackageName, setCreatedPackageName] = useState("");
  const [filteredList, setFilteredList] = useState<any[]>(props.meHealthPackageList || []);
  const [isSearching, setIsSearching] = useState(false);
  const [errors, setErrors] = useState({
    packageCode: false,
    packageName: false,
    price: false,
    credits: false,
    startDate: false,
    startTime: false,
    endDate: false,
    endTime: false,
    saleStatus: false,
    dateRange: false,
  });
  const [openSettingPackage, setOpenSettingPackage] = useState(false);
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const [searchDateFrom, setSearchDateFrom] = useState(formatDateBE(firstDay));
  const [searchDateTo, setSearchDateTo] = useState(formatDateBE(lastDay));
  const [activeSettingPage, setActiveSettingPage] = useState(1);
  const [editorContent, setEditorContent] = useState("");
  const [openSuccessSettingTerm, setOpenSuccessSettingTerm] = useState(false);
  const [loadingButton, setLoadingButton] = useState<"draft" | "publish" | null>(null);

  const handlePageChange = (_e: any, { activePage }: any) => {
    setActivePage(activePage);
  };

  const historyData = props.termsAndConditionsActionLogList || [];

  const totalPages = Math.max(
    1,
    Math.ceil((props.meHealthPackageList?.length || 1) / ROWS_PER_PAGE)
  );

  const displayedRows = historyData.slice(
    (activeSettingPage - 1) * DEFAULT_ROWS,
    activeSettingPage * DEFAULT_ROWS
  );

  const emptyRowsCount = Math.max(DEFAULT_ROWS - displayedRows.length, 0);
  const emptyRows = Array.from({ length: emptyRowsCount });
  const sanitizeHtml = (
    html: string,
    allowedTags: string[] = ["ul", "ol", "li", "p", "br"]
  ): string => {
    if (!html) return "";

    let cleanHtml = html.replace(/<\/?([a-z][a-z0-9]*)\b[^>]*>/gi, (match, tag) => {
      return allowedTags.includes(tag.toLowerCase()) ? match : "";
    });

    cleanHtml = cleanHtml
      .replace(/<ul(?![^>]*style=)/gi, '<ul style="margin-left: 20px;"')
      .replace(/<ol(?![^>]*style=)/gi, '<ol style="margin-left: 20px;"');

    return cleanHtml;
  };

  const handleClick = (isPublish: boolean) => {
    setLoadingButton(isPublish ? "publish" : "draft");
    handleSaveOrCreateTerms(editorContent, isPublish);
  };

  const panes = [
    {
      menuItem: "ตั้งค่าเงื่อนไขการให้บริการ",
      render: () => (
        <Tab.Pane>
          <p style={{ marginTop: "40px" }}>
            สำหรับระบุรายละเอียดเงื่อนไขการให้บริการ รายละเอียดที่ระบุจะแสดงที่หน้าจอ Billing &
            Package
          </p>
          <SunEditor
            setOptions={{
              buttonList: [
                ["formatBlock"],
                ["blockquote"],
                ["bold", "underline", "italic", "strike"],
                ["fontColor", "hiliteColor"],
                ["align", "list"],
                ["outdent", "indent"],
              ],
              minHeight: "200px",
              maxHeight: "400px",
            }}
            onChange={(content) => setEditorContent(content)}
            defaultValue={editorContent}
          />

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: "6rem",
            }}
          >
            <Button
              onClick={() => {
                setOpenSettingPackage(false);
                setActiveTabIndex(0);
                setSearchDateFrom(formatDateBE(firstDay));
                setSearchDateTo(formatDateBE(lastDay));
              }}
              style={{ color: "white", backgroundColor: COLOR.gray }}
            >
              ปิดหน้าจอ
            </Button>
            <div style={{ display: "flex", gap: "10px" }}>
              <ButtonLoadCheck
                setProp={props.setProp}
                onClick={() => handleClick(false)}
                paramKey={
                  props.buttonLoadCheck?.createTermsAndConditions
                    ? "createTermsAndConditions"
                    : "updateTermsAndConditions"
                }
                buttonLoadCheck={
                  loadingButton === "draft"
                    ? props.buttonLoadCheck?.createTermsAndConditions ||
                      props.buttonLoadCheck?.updateTermsAndConditions
                    : undefined
                }
                name="DRAFT"
                title="บันทึกร่าง"
                style={{ color: "white", backgroundColor: COLOR.gray }}
              />
              <ButtonLoadCheck
                setProp={props.setProp}
                onClick={() => handleClick(true)}
                paramKey={
                  props.buttonLoadCheck?.createTermsAndConditions
                    ? "createTermsAndConditions"
                    : "updateTermsAndConditions"
                }
                buttonLoadCheck={
                  loadingButton === "publish"
                    ? props.buttonLoadCheck?.createTermsAndConditions ||
                      props.buttonLoadCheck?.updateTermsAndConditions
                    : undefined
                }
                name="PUBLISH"
                title="เผยแพร่"
                style={{ color: "white", backgroundColor: COLOR.gray }}
              />
            </div>
          </div>
        </Tab.Pane>
      ),
    },
    {
      menuItem: "ประวัติการแก้ไขเงื่อนไขการให้บริการ",
      render: () => (
        <Tab.Pane>
          <div
            style={{
              display: "flex",
              gap: "10px",
              marginBottom: "1rem",
              alignItems: "center",
              marginTop: "40px",
            }}
          >
            วันเวลาที่แก้ไขล่าสุด
            <DateTextBox
              value={searchDateFrom}
              onChange={(date: any) => setSearchDateFrom(date)}
              inputStyle={{ width: "150px" }}
              setLanguage={"th"}
              placeholder="DD/MM/YYYY"
            />
            <DateTextBox
              value={searchDateTo}
              onChange={(date: any) => setSearchDateTo(date)}
              inputStyle={{ width: "150px" }}
              setLanguage={"th"}
              placeholder="DD/MM/YYYY"
            />
            <Button
              style={{
                backgroundColor: COLOR.primary,
                color: "white",
                marginLeft: "20px",
                width: "150px",
              }}
              loading={props.buttonLoadCheck?.getTermsAndConditionsActionLogList === "LOADING"}
              onClick={() => {
                props.onEvent({
                  message: "HandleGetTermsAndConditionsActionLogList",
                  params: {
                    start_date: toApiDate(searchDateFrom),
                    end_date: toApiDate(searchDateTo),
                  },
                });
                setActiveSettingPage(1);
              }}
            >
              ค้นหา
            </Button>
          </div>
          <div
            style={{
              maxHeight: "400px",
              overflowY: "auto",
              overflowX: "auto",
            }}
          >
            <Table celled structured>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>วันเวลาที่แก้ไขล่าสุด</Table.HeaderCell>
                  <Table.HeaderCell>ผู้ที่แก้ไขล่าสุด</Table.HeaderCell>
                  <Table.HeaderCell>รายละเอียดเงื่อนไขการให้บริการ</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {displayedRows.map((row: any, idx: any) => (
                  <Table.Row key={`row-${idx}`}>
                    <Table.Cell>
                      {(() => {
                        const dt = new Date(row.datetime);
                        const day = String(dt.getDate()).padStart(2, "0");
                        const month = String(dt.getMonth() + 1).padStart(2, "0");
                        const year = dt.getFullYear();
                        const hours = String(dt.getHours()).padStart(2, "0");
                        const minutes = String(dt.getMinutes()).padStart(2, "0");
                        return `${day}/${month}/${year} ${hours}:${minutes}`;
                      })()}
                    </Table.Cell>
                    <Table.Cell>{row.user_name || "-"}</Table.Cell>
                    <Table.Cell>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: sanitizeHtml(row.content),
                        }}
                      />
                    </Table.Cell>
                  </Table.Row>
                ))}

                {emptyRows.map((_, idx) => (
                  <Table.Row key={`empty-${idx}`}>
                    <Table.Cell>&nbsp;</Table.Cell>
                    <Table.Cell>&nbsp;</Table.Cell>
                    <Table.Cell>&nbsp;</Table.Cell>
                  </Table.Row>
                ))}
              </Table.Body>
            </Table>
          </div>
          <div style={{ display: "flex", justifyContent: "center", marginTop: "1rem" }}>
            <Pagination
              activePage={activeSettingPage}
              totalPages={Math.ceil(historyData.length / DEFAULT_ROWS) || 1}
              onPageChange={(e, { activePage }) => setActiveSettingPage(Number(activePage))}
              ellipsisItem={{ content: "…", icon: true }}
              boundaryRange={2}
              siblingRange={1}
            />
          </div>
          <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "1rem" }}>
            <Button
              onClick={() => {
                setOpenSettingPackage(false);
                setActiveTabIndex(0);
                setSearchDateFrom(formatDateBE(firstDay));
                setSearchDateTo(formatDateBE(lastDay));
              }}
              style={{ color: "white", backgroundColor: COLOR.gray }}
            >
              ปิดหน้าจอ
            </Button>
          </div>
        </Tab.Pane>
      ),
    },
  ];

  const handleCreateHealthPackage = () => {
    const payload = {
      name: packageName,
      code: packageCode,
      credit_amount: Number(credits) || 0,
      price: Number(price) || 0,
      start_date: formatDateTimeToISO(startDate, startTime),
      end_date: formatDateTimeToISO(endDate, endTime),
      active_flag: saleStatus || "INACTIVE",
    };

    console.log("Creating package with:", payload);

    props.onEvent({
      message: "HandleCreateMeHealthPackage",
      params: {
        data: payload,
      },
    });
  };

  const handleSearchPackage = () => {
    setIsSearching(true);

    setTimeout(() => {
      const lowerName = filterName.trim().toLowerCase();
      const list = props.meHealthPackageList?.items || props.meHealthPackageList || [];

      const filtered = list.filter((pkg: any) => {
        const matchesName =
          !filterName ||
          pkg.name?.toLowerCase().includes(lowerName) ||
          pkg.code?.toLowerCase().includes(lowerName);

        const matchesStatus =
          !filterStatus || filterStatus === "all" || pkg.active_flag === filterStatus;

        if (filterName && filterStatus && filterStatus !== "all") {
          return matchesName && matchesStatus;
        } else if (filterName) {
          return matchesName;
        } else if (filterStatus && filterStatus !== "all") {
          return matchesStatus;
        }
        return true;
      });

      setFilteredList(filtered);
      setIsSearching(false);
    }, 0);
  };

  const handleUpdateHealthPackage = () => {
    if (!selectedPackage) return;

    const payload = {
      name: packageName,
      code: packageCode,
      credit_amount: Number(credits) || 0,
      price: Number(price) || 0,
      start_date: formatDateTimeToISO(startDate, startTime),
      end_date: formatDateTimeToISO(endDate, endTime),
      active_flag: saleStatus || "INACTIVE",
    };

    console.log("Updating package with:", payload);

    props.onEvent({
      message: "HandleUpdateMeHealthPackage",
      params: {
        pk: selectedPackage.id,
        data: payload,
      },
    });
  };

  const handleSaveOrCreateTerms = (content: string, isPublish: boolean = false) => {
    const latestTerm = props.latestTermAndConditions;
    const termId = latestTerm?.id;
    const hasLatestTerm = !!termId;

    if (hasLatestTerm) {
      console.log("Updating existing term:", termId);
      props.onEvent({
        message: "HandleUpdateTermsAndConditions",
        params: {
          data: {
            id: termId,
            content,
            isPublish,
          },
        },
      });
    } else {
      const action = isPublish ? "PUBLISH" : "DRAFT";
      const payload = {
        category: "SERVICE",
        action,
        content,
      };
      props.onEvent({
        message: "HandleCreateTermsAndConditions",
        params: { data: payload },
      });
    }
  };

  const renderError = (field: keyof typeof errors) => {
    if (!errors[field]) return null;
    return (
      <span style={{ color: "red", fontSize: "12px", marginLeft: "220px", marginBottom: "1rem" }}>
        กรุณากรอกข้อมูล
      </span>
    );
  };

  type ErrorField = keyof typeof errors;

  const clearError = (field: ErrorField) => {
    if (errors[field]) {
      setErrors((prev) => ({ ...prev, [field]: false }));
    }
  };

  const timeRegex = /^(?:[01]\d|2[0-3]):[0-5]\d$/;

  useEffect(() => {
    props.onEvent({
      message: "HandleGetMeHealthPackageList",
    });
    props.onEvent({
      message: "HandleGetTermsAndConditionsList",
    });
    props.onEvent({
      message: "HandleGetLatestTermsAndConditions",
    });
    props.onEvent({
      message: "HandleGetTermsAndConditionsActionLogList",
    });
  }, []);

  useEffect(() => {
    const cleanNumber = (val: any) => (val ? parseFloat(String(val).replace(/,/g, "")) : "");
    if (selectedPackage && isEditing) {
      const cleanedPrice = cleanNumber(selectedPackage.price);

      setPackageCode(selectedPackage.code || "");
      setPackageName(selectedPackage.name || "");
      setPrice(cleanedPrice ? cleanedPrice.toFixed(2) : "");
      setCredits(selectedPackage.credit_amount || "");
      setStartDate(moment(selectedPackage.started_at).format("DD/MM/YYYY") || "");
      setStartTime(moment(selectedPackage.started_at).format("HH:mm") || "00:00");
      setEndDate(moment(selectedPackage.ended_at).format("DD/MM/YYYY") || "");
      setEndTime(moment(selectedPackage.ended_at).format("HH:mm") || "00:00");
      setSaleStatus(selectedPackage.active_flag || "");
    } else if (!isEditing) {
      setPackageCode("");
      setPackageName("");
      setPrice("");
      setCredits("");
      setStartDate("");
      setStartTime("00:00");
      setEndDate("");
      setEndTime("00:00");
      setSaleStatus("");
    }
  }, [selectedPackage, isEditing]);

  useEffect(() => {
    if (
      props.buttonLoadCheck?.createMeHealthPackage === "SUCCESS" ||
      props.buttonLoadCheck?.updateMeHealthPackage === "SUCCESS"
    ) {
      setCreatedPackageName(packageName);
      setOpenAddNewPackage(false);
      setOpenSuccessAddNewPackage(true);
    }
  }, [props.buttonLoadCheck?.createMeHealthPackage, props.buttonLoadCheck?.updateMeHealthPackage]);

  useEffect(() => {
    if (
      props.buttonLoadCheck?.createTermsAndConditions === "SUCCESS" ||
      props.buttonLoadCheck?.updateTermsAndConditions === "SUCCESS"
    ) {
      setOpenSettingPackage(false);
      setOpenSuccessSettingTerm(true);
      props.onEvent({
        message: "HandleGetTermsAndConditionsActionLogList",
      });
    }
    console.log(
      props.buttonLoadCheck?.createTermsAndConditions,
      props.buttonLoadCheck?.updateTermsAndConditions
    );
  }, [
    props.buttonLoadCheck?.createTermsAndConditions,
    props.buttonLoadCheck?.updateTermsAndConditions,
  ]);

  useEffect(() => {
    if (props.latestTermAndConditions?.content || openSettingPackage || activeTabIndex === 0) {
      setEditorContent(props.latestTermAndConditions?.content || "");
    } else {
      setEditorContent("");
    }
  }, [props.latestTermAndConditions, openSettingPackage, activeTabIndex]);

  useEffect(() => {
    setFilteredList(props.meHealthPackageList || []);
  }, [props.meHealthPackageList]);

  return (
    <div className="card-seller-setting-package" style={{ padding: "15px 0" }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: 20,
          padding: "0 15px",
        }}
      >
        <Header style={{ color: "rgb(79,79,79)", margin: 0 }} as="h2">
          ตั้งค่าสำหรับเปิดขาย Package ให้กับ OA
        </Header>
      </div>
      <div
        style={{
          height: "calc(100vh - 250px)",
          overflowY: "auto",
          paddingRight: "8px",
          marginLeft: "20px",
        }}
      >
        <div
          style={{
            marginBottom: "1rem",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-end",
          }}
        >
          <div style={{ display: "flex", gap: "1rem", alignItems: "flex-end" }}>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <span style={{ marginBottom: "0.5rem" }}></span>
              <Input
                icon={{ name: "search" }}
                iconPosition="left"
                placeholder="ค้นหาด้วยชื่อ Package"
                value={filterName}
                onChange={(e) => setFilterName(e.target.value)}
                style={{
                  minWidth: "300px",
                  height: "38px",
                }}
              />
            </div>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <span style={{ marginBottom: "0.5rem" }}>สถานะการเปิดขาย</span>
              <Dropdown
                search
                selection
                options={STATUS_OPTIONS}
                value={filterStatus}
                onChange={(e, { value }: any) => setFilterStatus(value)}
                style={{
                  minWidth: "200px",
                  height: "38px",
                  display: "flex",
                  alignItems: "center",
                }}
              />
            </div>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <Button
                style={{
                  color: "white",
                  backgroundColor: COLOR.primary,
                  height: "38px",
                }}
                loading={isSearching}
                onClick={handleSearchPackage}
              >
                ค้นหา
              </Button>
            </div>
          </div>
          <div style={{ display: "flex", gap: "1rem" }}>
            <Button
              style={{
                color: "white",
                backgroundColor: "#757575",
                height: "38px",
                textAlign: "center",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "6px",
              }}
              onClick={() => setOpenSettingPackage(true)}
            >
              <img
                src={ICON.IconSetting}
                alt="Setting"
                style={{
                  width: "20px",
                  height: "20px",
                  display: "block",
                }}
              />
              ตั้งค่าเงื่อนไขบริการ
            </Button>

            <Button
              style={{
                color: "white",
                backgroundColor: COLOR.primary,
                height: "38px",
              }}
              onClick={() => {
                setIsEditing(false);
                setSelectedPackage(null);
                setOpenAddNewPackage(true);
              }}
            >
              <Icon name="plus" />
              เพิ่มรายการใหม่
            </Button>
          </div>
        </div>

        <div style={{ fontWeight: "normal" }}>
          <Table
            celled
            structured
            selectable
            className="no-vertical-lines"
            style={{ textAlign: "center" }}
          >
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>ชื่อ Package</Table.HeaderCell>
                <Table.HeaderCell>ราคา (ไม่รวมภาษีมูลค่าเพิ่ม)</Table.HeaderCell>
                <Table.HeaderCell>จำนวน Credit ที่ได้รับ</Table.HeaderCell>
                <Table.HeaderCell>Start Date</Table.HeaderCell>
                <Table.HeaderCell>End Date</Table.HeaderCell>
                <Table.HeaderCell>สถานะการเปิดขาย</Table.HeaderCell>
                <Table.HeaderCell>Actions</Table.HeaderCell>
              </Table.Row>
            </Table.Header>

            <Table.Body>
              {(filteredList?.length ? filteredList : []).map((pkg: any) => (
                <Table.Row key={pkg.id}>
                  <Table.Cell style={{ textAlign: "left" }}>{pkg.name || "-"}</Table.Cell>
                  <Table.Cell style={{ textAlign: "right" }}>฿ {pkg.price || "-"}</Table.Cell>
                  <Table.Cell style={{ textAlign: "right" }}>
                    {pkg.credit_amount.replace(/\B(?=(\d{3})+(?!\d))/g, ",") || "-"}
                  </Table.Cell>
                  <Table.Cell>
                    {pkg.started_at ? moment(pkg.started_at).format("DD/MM/YYYY HH:mm") : "-"}
                  </Table.Cell>
                  <Table.Cell>
                    {pkg.ended_at ? moment(pkg.ended_at).format("DD/MM/YYYY HH:mm") : "-"}
                  </Table.Cell>
                  <Table.Cell>
                    <div
                      style={{
                        color: pkg.active_flag === "ACTIVE" ? "#568729" : "#ff0000",
                        backgroundColor: pkg.active_flag === "ACTIVE" ? "rgba(145,197,97,0.46)" : "#ffd7d7",
                        borderRadius: "25px",
                        padding: "5px",
                      }}
                    >
                      {pkg.active_flag === "ACTIVE"
                        ? "เปิดขาย"
                        : pkg.active_flag === "INACTIVE"
                        ? "ยังไม่เปิดขาย"
                        : "-"}
                    </div>
                  </Table.Cell>
                  <Table.Cell>
                    <div
                      style={{
                        borderRadius: "6px",
                        backgroundColor: COLOR.light_gray,
                        cursor: "pointer",
                        padding: "5px",
                      }}
                      onClick={() => {
                        setIsEditing(true);
                        setSelectedPackage(pkg);
                        setOpenAddNewPackage(true);
                      }}
                    >
                      <Icon name="edit" size="small" style={{ color: "#2b2b2b" }} />
                      แก้ไขรายการ
                    </div>
                  </Table.Cell>
                </Table.Row>
              ))}

              {Array.from({
                length: Math.max(
                  0,
                  ROWS_PER_PAGE - (filteredList?.length || props.meHealthPackageList?.length || 0)
                ),
              }).map((_, idx) => (
                <Table.Row key={`empty-${idx}`} style={{ height: "50px" }}>
                  <Table.Cell>&nbsp;</Table.Cell>
                  <Table.Cell>&nbsp;</Table.Cell>
                  <Table.Cell>&nbsp;</Table.Cell>
                  <Table.Cell>&nbsp;</Table.Cell>
                  <Table.Cell>&nbsp;</Table.Cell>
                  <Table.Cell>&nbsp;</Table.Cell>
                  <Table.Cell>&nbsp;</Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
        </div>
        <div style={{ display: "flex", justifyContent: "center", marginTop: "1rem" }}>
          <Pagination
            activePage={activePage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
          />
        </div>
        <Modal
          open={openAddNewPackage}
          onClose={() => {
            setOpenAddNewPackage(false);
            setIsEditing(false);
            setSelectedPackage(null);
            setPackageCode("");
            setPackageName("");
            setPrice("");
            setCredits("");
            setStartDate("");
            setStartTime("00:00");
            setEndDate("");
            setEndTime("00:00");
            setSaleStatus("");
            setErrors({
              packageCode: false,
              packageName: false,
              price: false,
              credits: false,
              startDate: false,
              startTime: false,
              endDate: false,
              endTime: false,
              saleStatus: false,
              dateRange: false,
            });
          }}
          size="large"
          style={{ padding: "20px" }}
        >
          <Modal.Content>
            <h3 style={{ fontSize: "20px" }}>
              {isEditing ? "แก้ไขรายการ Package" : "สร้างรายการ Package ใหม่"}
            </h3>
            <div
              style={{
                width: "100%",
                height: "3px",
                backgroundColor: COLOR.primary,
                marginBottom: "2rem",
              }}
            ></div>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: errors.packageCode ? 0 : "1rem",
                }}
              >
                <label style={{ minWidth: "220px" }}>
                  รหัสแพ็กเกจ <span style={{ color: "red" }}>*</span>
                </label>
                <Input
                  value={packageCode}
                  onChange={(e) => {
                    setPackageCode(e.target.value);
                    clearError("packageCode");
                  }}
                  placeholder="ระบุรหัสแพ็กเกจ"
                  style={{ flex: 1 }}
                  disabled={isEditing && selectedPackage.active_flag === "ACTIVE"}
                />
              </div>
              {renderError("packageCode")}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: errors.packageName ? 0 : "1rem",
                }}
              >
                <label style={{ minWidth: "220px" }}>
                  ชื่อแพ็กเกจ <span style={{ color: "red" }}>*</span>
                </label>
                <Input
                  value={packageName}
                  onChange={(e) => {
                    setPackageName(e.target.value);
                    clearError("packageName");
                  }}
                  placeholder="ระบุชื่อแพ็กเกจ"
                  style={{ flex: 1 }}
                  disabled={isEditing && selectedPackage.active_flag === "ACTIVE"}
                />
              </div>
              {renderError("packageName")}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: errors.price ? 0 : "1rem",
                }}
              >
                <label style={{ minWidth: "220px" }}>
                  ราคา (ไม่รวมภาษีมูลค่าเพิ่ม) <span style={{ color: "red" }}>*</span>
                </label>
                <Input
                  type="text"
                  value={price}
                  onChange={(e) => {
                    const val = e.target.value;
                    if (/^\d*\.?\d{0,2}$/.test(val) || val === "") {
                      setPrice(val);
                    }
                    clearError("price");
                  }}
                  disabled={isEditing && selectedPackage.active_flag === "ACTIVE"}
                  onBlur={() => {
                    if (price !== "" && !isNaN(Number(price))) {
                      setPrice(parseFloat(price).toFixed(2));
                    }
                  }}
                  placeholder="ระบุราคาที่ยังไม่รวมภาษีมูลค่าเพิ่ม"
                  style={{ flex: 1 }}
                />
              </div>
              {renderError("price")}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: errors.credits ? 0 : "1rem",
                }}
              >
                <label style={{ minWidth: "220px" }}>
                  จำนวนเครดิตที่ได้รับ <span style={{ color: "red" }}>*</span>
                </label>
                <Input
                  type="text"
                  value={credits}
                  onChange={(e) => {
                    const val = e.target.value;
                    if (/^\d*\.?\d{0,2}$/.test(val) || val === "") {
                      setCredits(val);
                    }
                    clearError("credits");
                  }}
                  disabled={isEditing && selectedPackage.active_flag === "ACTIVE"}
                  onBlur={() => {
                    if (credits !== "" && !isNaN(Number(credits))) {
                      setCredits(parseFloat(credits).toFixed(2));
                    }
                  }}
                  placeholder="ระบุจำนวนเครดิตที่ได้รับ"
                  style={{ flex: 1 }}
                />
              </div>
              {renderError("credits")}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <label style={{ minWidth: "220px" }}>
                  วันเวลาเริ่มต้นการขาย <span style={{ color: "red" }}>*</span>
                </label>
                <div style={{ display: "flex", gap: "10px", flex: 1 }}>
                  <DateTextBox
                    value={startDate}
                    onChange={(date: any) => {
                      setStartDate(beStringToAdString(date) || startDate);
                      clearError("startDate");
                    }}
                    inputStyle={{ width: "150px" }}
                    setLanguage={"th"}
                    placeholder="DD/MM/YYYY"
                    disabled={isEditing && selectedPackage.active_flag === "ACTIVE"}
                  />
                  <TimeInput
                    value={startTime}
                    onChange={setStartTime}
                    disabled={isEditing && selectedPackage.active_flag === "ACTIVE"}
                  />
                </div>
              </div>
              <div style={{ marginLeft: "220px", marginBottom: "1rem" }}>
                {(errors.startDate || errors.startTime) && (
                  <span style={{ color: "red", fontSize: "12px" }}>กรุณากรอกข้อมูล</span>
                )}
                {errors.dateRange && (
                  <span style={{ color: "red", fontSize: "12px" }}>
                    กรุณาระบุช่วงเวลาให้ถูกต้อง
                  </span>
                )}
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <label style={{ minWidth: "220px" }}>
                  วันเวลาสิ้นสุดการขาย <span style={{ color: "red" }}>*</span>
                </label>
                <div style={{ display: "flex", gap: "10px", flex: 1 }}>
                  <DateTextBox
                    value={endDate}
                    onChange={(date: any) => {
                      setEndDate(beStringToAdString(date) || endDate);
                      clearError("endDate");
                    }}
                    inputStyle={{ width: "150px" }}
                    setLanguage={"th"}
                    placeholder="DD/MM/YYYY"
                  />
                  <TimeInput value={endTime} onChange={setEndTime} />
                </div>
              </div>
              <div style={{ marginLeft: "220px", marginBottom: "1rem" }}>
                {(errors.endDate || errors.endTime) && (
                  <span style={{ color: "red", fontSize: "12px" }}>กรุณากรอกข้อมูล</span>
                )}
                {errors.dateRange && (
                  <span style={{ color: "red", fontSize: "12px" }}>
                    กรุณาระบุช่วงเวลาให้ถูกต้อง
                  </span>
                )}
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: errors.saleStatus ? 0 : "1rem",
                }}
              >
                <label style={{ minWidth: "220px" }}>
                  สถานะการขาย <span style={{ color: "red" }}>*</span>
                </label>
                <Dropdown
                  search
                  selection
                  placeholder="--เลือกสถานะ--"
                  options={SALE_STATUS_OPTIONS}
                  value={saleStatus}
                  onChange={(e, { value }: any) => {
                    setSaleStatus(value);
                    clearError("saleStatus");
                  }}
                  style={{ flex: 1 }}
                />
              </div>
            </div>
            {renderError("saleStatus")}
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "10px",
                marginTop: "2rem",
              }}
            >
              <Button
                onClick={() => {
                  setOpenAddNewPackage(false);
                  setIsEditing(false);
                  setSelectedPackage(null);
                  setPackageCode("");
                  setPackageName("");
                  setPrice("");
                  setCredits("");
                  setStartDate("");
                  setStartTime("00:00");
                  setEndDate("");
                  setEndTime("00:00");
                  setSaleStatus("");
                  setErrors({
                    packageCode: false,
                    packageName: false,
                    price: false,
                    credits: false,
                    startDate: false,
                    startTime: false,
                    endDate: false,
                    endTime: false,
                    saleStatus: false,
                    dateRange: false,
                  });
                }}
              >
                ปิดหน้าจอ
              </Button>
              <ButtonLoadCheck
                setProp={props.setProp}
                onClick={() => {
                  const newErrors = {
                    packageCode: !packageCode.trim(),
                    packageName: !packageName.trim(),
                    price: !price.trim(),
                    credits: !credits.trim(),
                    startDate: !startDate,
                    startTime: !startTime || !timeRegex.test(startTime),
                    endDate: !endDate,
                    endTime: !endTime || !timeRegex.test(endTime),
                    saleStatus: !saleStatus,
                    dateRange: false,
                  };

                  if (
                    !newErrors.startDate &&
                    !newErrors.startTime &&
                    !newErrors.endDate &&
                    !newErrors.endTime
                  ) {
                    const startISO = formatDateTimeToISO(startDate, startTime);
                    const endISO = formatDateTimeToISO(endDate, endTime);

                    if (startISO && endISO) {
                      const start = new Date(startISO).getTime();
                      const end = new Date(endISO).getTime();

                      if (start === end || end < start) {
                        newErrors.dateRange = true;
                      }
                    }
                  }

                  setErrors(newErrors);

                  const hasError = Object.values(newErrors).some((v) => v);
                  if (hasError) return;

                  if (isEditing) {
                    handleUpdateHealthPackage();
                  } else {
                    handleCreateHealthPackage();
                  }
                }}
                paramKey={isEditing ? "updateMeHealthPackage" : "createMeHealthPackage"}
                buttonLoadCheck={
                  isEditing
                    ? props.buttonLoadCheck?.updateMeHealthPackage
                    : props.buttonLoadCheck?.createMeHealthPackage
                }
                name="SAVE"
                title="บันทึกข้อมูล"
                style={{
                  backgroundColor: COLOR.primary,
                  color: "white",
                }}
              />
            </div>
          </Modal.Content>
        </Modal>
        <Modal
          open={openSuccessAddNewPackage}
          onClose={() => {
            setOpenSuccessAddNewPackage(false);
          }}
          size="mini"
          style={{ padding: "20px" }}
        >
          <Modal.Content>
            <h3 style={{ fontSize: "20px", textAlign: "center" }}>บันทึกข้อมูลสำเร็จ</h3>
            <div style={{ color: COLOR.primary, textAlign: "center", fontSize: "16px" }}>
              {createdPackageName || "-"}
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "10px",
                marginTop: "2rem",
              }}
            >
              <Button onClick={() => setOpenSuccessAddNewPackage(false)}>ปิด</Button>
            </div>
          </Modal.Content>
        </Modal>
        <Modal
          open={openSettingPackage}
          onClose={() => {
            setOpenSettingPackage(false);
            setActiveTabIndex(0);
            setSearchDateFrom(formatDateBE(firstDay));
            setSearchDateTo(formatDateBE(lastDay));
          }}
          size="large"
          style={{ minHeight: "550px", maxHeight: "550px" }}
        >
          <Modal.Content>
            <Tab
              panes={panes}
              activeIndex={activeTabIndex}
              onTabChange={(e, data) => setActiveTabIndex(Number(data.activeIndex))}
              menu={{ className: "custom-tab-menu" }}
            />
          </Modal.Content>
        </Modal>
        <Modal
          open={openSuccessSettingTerm}
          onClose={() => {
            setOpenSuccessSettingTerm(false);
          }}
          size="mini"
          style={{ padding: "20px" }}
        >
          <Modal.Content>
            <h3 style={{ fontSize: "20px", textAlign: "center" }}>
              ตั้งค่าเงื่อนไขการให้บริการสำเร็จ
            </h3>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "10px",
                marginTop: "2rem",
              }}
            >
              <Button onClick={() => setOpenSuccessSettingTerm(false)}>ปิด</Button>
            </div>
          </Modal.Content>
        </Modal>
      </div>
    </div>
  );
};

export default CardSellerSettingPackage;
